import { $deepclone } from './methods.js'

export const barOrLineChartFn = function(widgetType, {
  secondaryAxis,
  lineNorm
}, data) {
 // 柱状图、折线图、折柱图
  const {
    axis,
    dateRang,
    result,
    fields,
    compareResult
  } = data;
  const series = [];
  if (result && fields && fields.length  > 0) {
    fields.forEach((item) => {
      let symbol = item?.fieldUnit?.symbol?`(${item?.fieldUnit?.symbol})`:''
      const obj = {
        symbol: item?.fieldUnit?.symbol || '',
        name: `${item.name}${symbol}`,
        data: getTooltipAllXData(result[item.field] || [], item, dateRang, false, data, item?.fieldUnit?.symbol || ''),
        dataAll: 'dataAll',
        dateRang
      };
      if(obj.data && obj.data.length > 0){
        series.push(obj);
      }
      const compareData = compareResult ? compareResult[item.field] : [];
      if(compareData.length > 0){
        series.push({
          name: `${item.name}${symbol}(对比)`,
          symbol: item?.fieldUnit?.symbol,
          data: getTooltipAllXData(compareData, item, dateRang, true,data, item?.fieldUnit?.symbol)
        });
      }
    });
  }
  // series添加所有x轴对应的相关数据
  let allData = axis.map((v,i) => series.map(val => val.data[i]))
  series.forEach((oseries, childIndex) => {
    oseries.data.forEach((item, index) => {
      item.allData = $deepclone(allData[index]);
    })
    // 对于柱状折线图
    if(widgetType == "widget-barlinechart"&&oseries.data.length > 0){
      if(oseries.data[0].field === lineNorm){
        oseries.type = 'line'
        oseries.yAxisIndex = series.length === 2?1:0
      }else{
        oseries.type = 'bar'
      }
    }
    // 对于折线图
    if(widgetType == "widget-linechart"&&oseries.data[0].field === secondaryAxis){
      // 设置那条对应为多y轴
      oseries.yAxisIndex = 1
    }
  })
  return {
    xAxis: axis,
    series
  };
};
const getTooltipAllXData = function(arr, parentItem, dateRang, isDiff, allData, symbol){
  let arrData = [];
  const name = isDiff ? `${parentItem.name}(对比)` : parentItem.name
  if(arr.length > 0){
    arr.forEach(item =>{
      let toolObj = {
        value: item,
        name,
        field:parentItem.field,
        dateRang,
        isDiff,
        symbol
      }
      arrData.push(toolObj);
    })
  }
  return arrData;
}

// 组件拖入时 赋值
export const setDefaultValue = function(options) {
  let formData = {}
  if (options && options.length > 0) {
    for (let i = 0; i < options.length; i++) {
      const obj = options[i];
      if (Object.prototype.toString.call(obj) == "[object Object]") {
        formData[options[i].name] = $deepclone(options[i].value);
      } else if (Object.prototype.toString.call(obj) == "[object Array]") {
        for (let j = 0; j < obj.length; j++) {
          const list = obj[j].list;
          list.forEach((el) => {
            formData[el.name] = el.value;
          });
        }
      }
    }
    return Object.assign({}, formData)
  } else { return {} }
}

export default {
  barOrLineChartFn,
  setDefaultValue
};